// imove-branch: 是否非主办方管理页

export default async function(ctx) {
  const { HOST_ADMIN = [], pathname = '' } = ctx.payload;
  console.log(121111,HOST_ADMIN);
  if (HOST_ADMIN.indexOf(pathname) === -1) {
    return true;
  }
  return false;
}